import { modules } from "@/@core/utils/modules";

export default [
    {
        path: "aumento-sueldo",
        name: "rrhh-aumento-sueldo",
        redirect: { name: "rrhh-aumento-sueldo-solicitudes" },
        component: () => import("@/views/rrhh/views/aumento-sueldo/AumentoSueldo.vue"),
        meta: {
            module: modules.RRHH,
            section: 42,
            pageTitle: "Aumento de Sueldo",
            breadcrumb: [
                {
                    text: "Pending",
                    active: true,
                },
            ],
            tabs:[
                {
                    title: "Solicitudes",
                    name: "rrhh-aumento-sueldo-solicitudes",
                }
            ]
        },
        children: [
            {
                path: "solicitudes",
                name: "rrhh-aumento-sueldo-solicitudes",
                component: () => import("@/views/rrhh/views/aumento-sueldo/components/AumentoSueldoTable.vue"),
                meta: {
                    module: modules.RRHH,
                    section: 29,
                    pageTitle: "Solicitudes de Aumento de Sueldo",
                    breadcrumb: [
                        {
                            text: "Solicitudes",
                            active: true,
                        },
                    ],
                },
            }
        ]
    }
]